import React, { useState, useEffect } from 'react';
import style from '../css/Livechat.module.css';
import { FaMessage, FaX } from 'react-icons/fa6';
import { FaArrowAltCircleRight, FaPhoneAlt } from 'react-icons/fa';

function LiveChat() {
	const [open, setOpen] = useState(false);
	const [guestId, setGuestId] = useState(null);
	const [messages, setMessages] = useState([]);
	const [message, setMessage] = useState('');

	// ✅ Fetch or generate Guest ID
	useEffect(() => {
		let storedGuestId = localStorage.getItem('guest_id');
		if (storedGuestId) {
			setGuestId(storedGuestId);
			fetchMessages(storedGuestId);
		} else {
			fetch('https://hometech-repairs.in/homeTech/generate_guest_id.php')
				.then((res) => res.json())
				.then((data) => {
					if (data.guest_id) {
						setGuestId(data.guest_id);
						localStorage.setItem('guest_id', data.guest_id);
					}
				})
				.catch((error) => console.error('Guest ID Error:', error));
		}
	}, []);

	// ✅ Fetch messages for this Guest ID
	const fetchMessages = (id) => {
		fetch(
			`https://hometech-repairs.in/homeTech/get_messages.php?guest_id=${id}`
		)
			.then((res) => res.json())
			.then((data) => {
				console.log('Fetched Messages:', data); // Debugging
				if (data.messages) {
					setMessages(data.messages); // ✅ Correctly updating messages
				} else {
					console.error('No messages found:', data);
				}
			})
			.catch((error) => console.error('Message Fetch Error:', error));
	};

	// ✅ Auto-refresh messages every 2 sec
	useEffect(() => {
		if (guestId) {
			const interval = setInterval(() => fetchMessages(guestId), 2000);
			return () => clearInterval(interval);
		}
	}, [guestId]);

	// ✅ Send message function
	const sendMessage = () => {
		if (!message.trim()) return;

		const newMessage = { guest_id: guestId, sender: 'guest', message };

		fetch('https://hometech-repairs.in/homeTech/save_message.php', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(newMessage),
		})
			.then((res) => res.text()) // Read the response as text first
			.then((text) => {
				console.log('Response Text:', text); // Log the raw response
				try {
					const data = JSON.parse(text); // Now parse the text as JSON
					if (data.success) {
						setMessage('');
						fetchMessages(guestId); // Fetch messages immediately after sending
					} else {
						console.error('Error saving message:', data.error);
						alert('Error: ' + data.error);
					}
				} catch (error) {
					console.error('Message Send Error:', error);
					alert('Failed to parse response as JSON. Check console.');
				}
			})
			.catch((error) => {
				console.error('Message Send Error:', error);
				alert('Failed to send message. Check console.');
			});
	};

	return (
		<div className={style.container}>
			{/* {!open ? <p className={style.swing}>Instant live chat!</p> : null} */}
			{!open ? (
				<div className={style.div1} onClick={() => setOpen(true)}>
					<FaMessage size={20} color={'white'} />
					<p style={{color:'white '}}>Live Chat</p>
				</div>
			) : (
				<div className={style.modal}>
					<div className={style.header}>
						<p>Live Chat '9AM-6PM'</p>
						<div onClick={() => setOpen(false)}>
							<FaX size={20} color="white" />
						</div>
					</div>

					{/* Show Guest ID */}
					<div className={style.body}>
						{/* <p>
							Your Guest ID: <strong>{guestId || 'Loading...'}</strong>
						</p> */}

						{/* Chat Messages */}
						<div className={style.chatBox}>
							{messages.length === 0 ? (
								<div>
									<p>This space is waiting for your words ✨</p>
									{/* <p>Add free live chat to your site</p> */}
									<a href="tel:+917411741171" className={style.desc}>
										<FaPhoneAlt size={15} color="black" /> 7411741171
									</a>
								</div>
							) : (
								messages.map((msg, index) => (
									<div
										key={index}
										style={{
											textAlign: msg.sender === 'guest' ? 'right' : 'left',
										}}
									>
										<span
											style={{
												background:
													msg.sender === 'guest' ? 'green' : '#ffffff',
												padding: '5px',
												borderRadius: '5px',
												display: 'inline-block',
												margin: '5px',

												color: msg.sender === 'guest' ? 'white' : 'black',
											}}
										>
											{msg.message}
											<br />
											<span className={style.date}>
												{(() => {
													const date = new Date(msg.created_at);
													const day = String(date.getDate()).padStart(2, '0');
													const month = String(date.getMonth() + 1).padStart(
														2,
														'0'
													);
													const year = date.getFullYear();
													return `${day}-${month}-${year}`;
												})()}
											</span>
										</span>
									</div>
								))
							)}
						</div>

						{/* Message Input */}
						<div className={style.inputDiv}>
							<input
								type="text"
								placeholder="Type your message & press enter"
								className={style.input}
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								onKeyDown={(e) => e.key === 'Enter' && sendMessage()} // Send on Enter
							/>
							<div onClick={sendMessage}>
								<FaArrowAltCircleRight size={20} />
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default LiveChat;
